var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _vm.page.is_viewable
          ? _c("div", { staticClass: "lineup--template relative bg-beige" }, [
              _c(
                "div",
                {
                  staticClass:
                    "db dn-ns absolute is-black z-4000 bg-navy mobile-menu-lineup",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative flex flex-row items-center w-100 h3 bb-grey container-fluid",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex w-100 flex-row justify-between" },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "f3 mt2 ttu is-tablet-bold is-beige pointer",
                              attrs: {
                                href: _vm.lineup_nav_links_published[
                                  _vm.activeItemIndex
                                ].link,
                                title:
                                  _vm.lineup_nav_links_published[
                                    _vm.activeItemIndex
                                  ].title,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.lineup_nav_links_published[
                                    _vm.activeItemIndex
                                  ].title
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "w2 mt2 inline-flex pointer arrow-down-icon",
                              class: {
                                "is-clicked": _vm.mobileMenuIconIsClicked,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.mobileMenuIconIsClicked =
                                    !_vm.mobileMenuIconIsClicked
                                },
                              },
                            },
                            [
                              _c("simple-svg", {
                                staticClass: "green-arrow",
                                attrs: {
                                  filepath: "/uploads/plus.svg",
                                  id: "arrow-down-icon-id",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide-fade-rev" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mobileMenuIconIsClicked,
                            expression: "mobileMenuIconIsClicked",
                          },
                        ],
                        staticClass: "absolute bg-navy w-100 z-4000",
                      },
                      _vm._l(
                        _vm.lineup_nav_links_published,
                        function (item, index) {
                          return index != _vm.activeItemIndex
                            ? _c(
                                "div",
                                {
                                  key: item.title,
                                  staticClass:
                                    "relative flex flex-row items-center w-100 h3 container-fluid",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "f3 ttu mt2 is-tablet-bold is-beige pointer",
                                      attrs: {
                                        href: item.link,
                                        title: item.title,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;(_vm.activeItemIndex = index),
                                            (_vm.mobileMenuIconIsClicked =
                                              !_vm.mobileMenuIconIsClicked)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                ]
                              )
                            : _vm._e()
                        }
                      ),
                      0
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "relative" }, [
                _c("div", { staticClass: "relative z-content" }, [
                  _c(
                    "section",
                    { staticClass: "relative mw12 flex flex-row z-1" },
                    [
                      _vm.isWindowWidthMobile == true
                        ? _c("div", { staticClass: "w-100 dn-ns" }, [
                            _c("div", {
                              staticClass:
                                "container-fluid relative z-4 overflow-hidden",
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isWindowWidthMobile == false
                        ? _c(
                            "div",
                            { staticClass: "dn relative flex-ns flex-grow-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 mw-24rem pv5 pl5 minh-450",
                                },
                                [
                                  _c("div", { staticClass: "h-100" }, [
                                    _c(
                                      "div",
                                      { staticClass: "info-bg sticky-nav" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pr5" },
                                          _vm._l(
                                            _vm.page.lineup_nav.links,
                                            function (item, key) {
                                              return item.is_published
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "relative flex flex-row items-center tl w6 h3 bg-navy mb1 pl3 pointer select-hover-dt",
                                                      class: {
                                                        active:
                                                          _vm.desktopActive ==
                                                          key,
                                                      },
                                                      attrs: {
                                                        href: item.link,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "accordion",
                                                        {
                                                          attrs: {
                                                            index: key,
                                                            desktopActive:
                                                              _vm.desktopActive,
                                                          },
                                                          on: {
                                                            "update:desktopActive":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.desktopActive =
                                                                  $event
                                                              },
                                                            "update:desktop-active":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.desktopActive =
                                                                  $event
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            {
                                                              slot: "parent-nav-link",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "f3 is-tablet-bold ttu is-beige txt-color",
                                                                  class: {
                                                                    active:
                                                                      _vm.desktopActive ==
                                                                      key,
                                                                  },
                                                                  attrs: {
                                                                    href: item.link,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100 is-black lineup-margin" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ph6 mv5 z-4 relative" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "z-4 relative" },
                                        [
                                          _vm.isWindowWidthMobile == false
                                            ? _c(
                                                "div",
                                                { staticClass: "db relative" },
                                                [
                                                  _vm.lineupActive === 0
                                                    ? _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "relative f2 mv3 is-lorano-bold is-black",
                                                        },
                                                        [_vm._v("2021 Lineup")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.lineupActive === 1
                                                    ? _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "relative f2 mv3 is-lorano-bold is-black",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Soma Tent Lineup"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.lineupActive === 2
                                                    ? _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "relative f2 mv3 is-lorano-bold is-black",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "2021 The House by Heineken Lineup"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      ref: "embedContainer",
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        id: "dostuff-embed-container",
                                                      },
                                                    },
                                                    [
                                                      _c("div", {
                                                        attrs: {
                                                          id: "ds-fest",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "db dn-ns fixed top-0 bottom-0 w-100 bg-beige vh-100 z-3",
                  style: {
                    top: 10 * _vm.lineup_nav_links_published.length + "px",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "db dn-ns relative container-fluid z-content",
                  },
                  [
                    _c("div", { staticClass: "relative pv3 vh-50" }, [
                      this.$route.path === "/lineup/" ||
                      this.$route.path === "/lineup" ||
                      this.$route.path ===
                        "/lineup//lineup/#/lineup_groupings/interactive-lineup/" ||
                      this.$route.path ===
                        "/lineup//lineup/#/lineup_groupings/interactive-lineup/" ||
                      this.$route.path ===
                        "/lineup/#/lineup_groupings/by-day-lineup"
                        ? _c(
                            "h2",
                            { staticClass: "f2 mv3 is-lorano-bold is-black" },
                            [_vm._v("2021 Lineup")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lineupActive === 1
                        ? _c(
                            "h2",
                            { staticClass: "f2 mv3 is-lorano-bold is-black" },
                            [_vm._v("Soma Tent Lineup")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lineupActive === 2
                        ? _c(
                            "h2",
                            { staticClass: "f2 mv3 is-lorano-bold is-black" },
                            [_vm._v("2021 The House by Heineken Lineup")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "embedContainer",
                          staticClass: "w-100",
                          attrs: { id: "dostuff-embed-container" },
                        },
                        [_c("div", { attrs: { id: "ds-fest" } })]
                      ),
                    ]),
                  ]
                ),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "lineup--template relative bg-beige pb5" },
              [
                _c("div", { staticClass: "relative container-fluid pv4" }, [
                  _c(
                    "h2",
                    { staticClass: "f2 mv3 ttu is-tablet-bold is-black" },
                    [_vm._v("2021 info coming soon")]
                  ),
                ]),
              ]
            ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }